export const baseProjectDetailsUrl = '/projectDetails';

const urls = {
  base: '/',
  editor: '/editor',
  login: '/login',
  register: '/register',
  dashboard: '/dashboard',
  projectDetails: `${baseProjectDetailsUrl}/:projectId`,
  projectNotes: `${baseProjectDetailsUrl}/:projectId/notes`,
  projectNotesList: `${baseProjectDetailsUrl}/:projectId/notes/list`,
  projectNotesCorkboard: `${baseProjectDetailsUrl}/:projectId/notes/corkboard`,
  projectNotesTimeline: `${baseProjectDetailsUrl}/:projectId/notes/timeline`,
  // Corkboards routes
  projectCorkboards: `${baseProjectDetailsUrl}/:projectId/notes/corkboards`,
  projectCorkboardEditor: `${baseProjectDetailsUrl}/:projectId/notes/corkboards/:corkboardId`,
  // Timelines routes
  projectTimelines: `${baseProjectDetailsUrl}/:projectId/notes/timelines`,
  projectTimelineEditor: `${baseProjectDetailsUrl}/:projectId/notes/timelines/:timelineId`,
  // Game design routes
  projectGameDesign: `${baseProjectDetailsUrl}/:projectId/gamedesign`,
  projectGameDesignTool: `${baseProjectDetailsUrl}/:projectId/gamedesign/:gameTool`,
  // Characters routes
  projectCharacters: `${baseProjectDetailsUrl}/:projectId/characters`,
  privacy: '/privacy',
  settings: '/settings',
};

// Helper to generate project URLs with actual projectId
export const getProjectUrl = (projectId) => `${baseProjectDetailsUrl}/${projectId}`;
export const getNotesUrl = (projectId) => `${baseProjectDetailsUrl}/${projectId}/notes`;
export const getNotesListUrl = (projectId) => `${baseProjectDetailsUrl}/${projectId}/notes/list`;
export const getNotesCorkboardUrl = (projectId) =>
  `${baseProjectDetailsUrl}/${projectId}/notes/corkboard`;
export const getNotesTimelineUrl = (projectId) =>
  `${baseProjectDetailsUrl}/${projectId}/notes/timeline`;
// Corkboards URL helpers
export const getCorkboardsUrl = (projectId) =>
  `${baseProjectDetailsUrl}/${projectId}/notes/corkboards`;
export const getCorkboardEditorUrl = (projectId, corkboardId) =>
  `${baseProjectDetailsUrl}/${projectId}/notes/corkboards/${corkboardId}`;

// Timelines URL helpers
export const getTimelinesUrl = (projectId) =>
  `${baseProjectDetailsUrl}/${projectId}/notes/timelines`;
export const getTimelineEditorUrl = (projectId, timelineId) =>
  `${baseProjectDetailsUrl}/${projectId}/notes/timelines/${timelineId}`;

// Characters URL helpers
export const getCharactersUrl = (projectId) => `${baseProjectDetailsUrl}/${projectId}/characters`;

export default urls;
